import { lazy } from 'react';
import DashboardCustomizeOutlined from '@mui/icons-material/DashboardCustomizeOutlined';
import type { FeatureManifest } from '../registry';
import type { ShellHandle } from '../../components/shell/AppShell';
import { color } from '../../design/tokens';
import { createBoard, restoreBoard } from './api';
import type { NewSpaceAccessDto } from '../../../../shared/types/access';

const loadBoardPage = () => import('./BoardPage');
const BoardPage = lazy(loadBoardPage);

const immersive: ShellHandle = { immersive: true };

export const boardsFeature: FeatureManifest = {
    preload: loadBoardPage,
    type: 'board',
    label: 'Collab board',
    plural: 'Collab boards',
    tagline: 'Infinite canvas for stickies, clusters and dot votes.',
    Icon: DashboardCustomizeOutlined,
    accent: color.signal,
    pathPrefix: '/b',
    routes: [{ path: '/b/:shareId', element: <BoardPage />, handle: immersive }],
    create: async (title: string, access: NewSpaceAccessDto) => ({ shareId: (await createBoard({ title, ...access })).shareId }),
    restore: shareId => restoreBoard(shareId),
};
